<template lang="html">
    <div class="row mb-3">
        <label :class="'col-form-label col-sm-' + labelCols"
               :for="field.id"> {{ field.label }} {{
                field.required ? '*' : ''
            }} </label>
        <div :class="'col-sm-' + fieldCols">
            <template v-if="fieldData.type === 'Date'">
                <input :id="field.id"
                       :readonly="field.locked"
                       :placeholder="field.placeholder"
                       :required="field.required"
                       :value="valueDate"
                       class="form-control"
                       pattern="\d{4}-\d{2}-\d{2}"
                       type="date"
                       @input="changeValue($event.target.value, true)"/>
            </template>
            <template v-else>
                <div class="input-group">
                    <input :readonly="field.locked"
                           :placeholder="field.placeholder"
                           :value="valueDate"
                           class="form-control"
                           pattern="\d{4}-\d{2}-\d{2}"
                           type="date"
                           @input="changeValue($event.target.value, true)"/>
                    <input :readonly="field.locked"
                           :placeholder="field.placeholder"
                           :required="timeRequired"
                           :value="valueTime"
                           class="form-control"
                           type="time"
                           @input="changeValue($event.target.value)"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    },
    computed: {
        fieldData() {
            let parsedFieldData = {
                type: 'Date'
            }
            if (this.field.data !== '') {
                parsedFieldData = JSON.parse(this.field.data);
            }
            return parsedFieldData;
        },
        valueDate() {
            return this.value.split(' ')[0];
        },
        valueTime() {
            if (this.value !== '') {
                return this.value.split(' ')[1]
            }
            return '';
        },
        timeRequired() {
            return this.valueDate !== '';
        }
    },
    methods: {
        changeValue(value, isDate) {
            if (isDate) {
                this.$emit('update:modelValue', {value: value + ' ' + this.valueTime});
            } else {
                this.$emit('update:modelValue', {value: this.valueDate + ' ' + value});
            }
        }
    }
}
</script>